/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cal_4_DInputs */

const en_cp_cal_4_d = /** @type {(inputs: Cp_Cal_4_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5-minute demo to the lecturer + an outside mentor; measure the readiness score.`)
};

const id_cp_cal_4_d = /** @type {(inputs: Cp_Cal_4_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demo 5 menit ke dosen + mentor luar; ukur skor kesiapan.`)
};

/**
* | output |
* | --- |
* | "5-minute demo to the lecturer + an outside mentor; measure the readiness score." |
*
* @param {Cp_Cal_4_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cal_4_d = /** @type {((inputs?: Cp_Cal_4_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cal_4_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cal_4_d(inputs)
	return en_cp_cal_4_d(inputs)
});